import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { fetchAllCompanies, type Company } from '@/lib/api/endpoints/companies'

export function useCompanies(): UseQueryResult<Company[]> {
  return useQuery({
    queryKey: ['companies', 'all'],
    queryFn: () => fetchAllCompanies(),
    staleTime: 30_000,
  })
}
